import { NotificationsActive, Visibility } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from "@mui/material";

interface PublishCollectionDialogInterface {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    updateCollectionDetails: () => void;
}

export default function PublishCollectionDialog({ open, setOpen, updateCollectionDetails }: PublishCollectionDialogInterface) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="first-publish-dialog-title"
            aria-describedby="first-publish-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle 
                id="first-publish-dialog-title"
                sx={{ 
                    fontSize: '1.2rem',
                    fontWeight: 600,
                }}
            >
                Ready to Publish?
            </DialogTitle>

            <DialogContent sx={{ pt: 1, pb: 2 }}>
                <DialogContentText 
                    id="first-publish-dialog-description"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                    }}
                >
                    Note that publishing this collection for the first time time will trigger a
                    notification to your students, and they'll be able to assess this collection resources.
                </DialogContentText>
            </DialogContent>


             <DialogActions sx={{ px: 3, pb: 3, }}>
                <Button
                    onClick={() => setOpen(false)}
                    variant="outlined"
                    sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        borderColor: '#d1d5db',
                        color: '#6b7280',
                        '&:hover': {
                            borderColor: '#9ca3af',
                            backgroundColor: '#f9fafb'
                        }
                    }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={() => {
                        setOpen(false);
                        updateCollectionDetails();
                    }}
                    variant="contained"
                    sx={{ 
                        backgroundColor: "#10b981",
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        py: 1,
                        boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
                        '&:hover': {
                            backgroundColor: "#059669",
                            boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Publish
                </Button>
            </DialogActions>
        </Dialog>
    );
}